import { render, staticRenderFns } from "./capacitaciones_agenda.vue?vue&type=template&id=68d8d1ea"
import script from "./capacitaciones_agenda.vue?vue&type=script&lang=js"
export * from "./capacitaciones_agenda.vue?vue&type=script&lang=js"
import style0 from "./capacitaciones_agenda.vue?vue&type=style&index=0&id=68d8d1ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports